import { Component } from "react";
import { connect } from "react-redux";
import { fetchingTransactionAction, updateTransactionAction, updateAppConfigAction } from "../../../redux/actions";
import { betCondition, isDesktop, isMobile, setClassNameCondition, navigateTo, formatDMY } from "../../helper";
import constants from "../../constants";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { withTranslation } from "react-i18next";
const TRANSACTION_STATUS = constants.TRANSACTION_STATUS;

class TransactionBox extends Component {
	constructor(props) {
		super(props);
	}

	onChangeSelectedTab = (tab) => (e) => {
		e.preventDefault();
		this.props.updateTransactionAction({ selected_tab: tab });
		this.props.fetchingTransactionAction();
	}
	goToDashBoard = () => {
		navigateTo('dashboard').bind(this)();
	}
	close = () => {
		this.props.updateAppConfigAction({ ['is_show_transaction']: false });
	}
	groupTransaction = (transactions) => {
		return transactions.reduce((acc, item) => {
			const date = formatDMY(item.created_at);
			if (!acc[date]) {
				acc[date] = []
			}
			acc[date].push(item);
			return acc;
		}, {});
	}
	render() {
		const { t } = this.props;
		let { selected_tab, transactions, total_bet_open } = this.props.transactionReducer;
		let groupedTransaction = this.groupTransaction(transactions);
		return <div data-v-2bbc4f3d="" data-v-5b2de64c="" id="binaryTransaction">
			{isMobile() && <>
				<div className="d-flex align-items-center p-3">
					<i onClick={this.close} className="fas fa-arrow-left text white"></i>
					<p className="text-white font-weight-bold ml-3">{t("TransactionHistory")}</p>
				</div>
				<ul data-v-2bbc4f3d="" id="myTab" role="tablist" className="nav nav-tabs mt-3">
					<li data-v-2bbc4f3d="" className="nav-item">
						<a data-v-2bbc4f3d=""
							onClick={this.onChangeSelectedTab(TRANSACTION_STATUS.PENDING)}
							data-toggle="tab" href="#"
							role="tab" aria-controls={TRANSACTION_STATUS.PENDING}
							aria-selected={selected_tab === TRANSACTION_STATUS.PENDING}
							className={`${selected_tab === TRANSACTION_STATUS.PENDING ? 'btn btn-primary-custom' : 'btn bg-grey'} w-100`}>
							<span data-v-2bbc4f3d="" className="font-14 font-weight-bold">{t("OpenOrder")} </span>
							<span data-v-2bbc4f3d=""
								className="totalCount text-uppercase"
								style={{ display: total_bet_open > 0 ? 'initial' : 'none' }}>{total_bet_open}</span></a>
					</li>
					<li data-v-2bbc4f3d="" className="nav-item ml-2">
						<a data-v-2bbc4f3d=""
							onClick={this.onChangeSelectedTab(TRANSACTION_STATUS.FINISH)}
							data-toggle="tab" href="#"
							role="tab" aria-controls={TRANSACTION_STATUS.FINISH}
							aria-selected={selected_tab === TRANSACTION_STATUS.FINISH}
							className={`${selected_tab === TRANSACTION_STATUS.FINISH ? 'btn btn-primary-custom' : 'btn bg-grey'} w-100`}>
							<span data-v-2bbc4f3d="" className="font-14 font-weight-bold">{t("CloseOrder")}</span>
						</a>
					</li>
				</ul>
			</>
			}
			{isDesktop() && <ul data-v-2bbc4f3d="" id="myTab" role="tablist" className="nav nav-tabs">
				<li data-v-2bbc4f3d="" className="nav-item">
					<a data-v-2bbc4f3d=""
						onClick={this.onChangeSelectedTab(TRANSACTION_STATUS.PENDING)}
						data-toggle="tab" href="#"
						role="tab" aria-controls={TRANSACTION_STATUS.PENDING}
						aria-selected={selected_tab === TRANSACTION_STATUS.PENDING}
						className={setClassNameCondition(selected_tab === TRANSACTION_STATUS.PENDING, 'active show', '', 'nav-link')}>
						<span data-v-2bbc4f3d="" className="text-uppercase">{t("Open")}</span>
						<span data-v-2bbc4f3d=""
							className="totalCount text-uppercase"
							style={{ display: total_bet_open > 0 ? 'initial' : 'none' }}>{total_bet_open}</span></a>
				</li>
				<li data-v-2bbc4f3d="" className="nav-item">
					<a data-v-2bbc4f3d=""
						onClick={this.onChangeSelectedTab(TRANSACTION_STATUS.FINISH)}
						data-toggle="tab" href="#"
						role="tab" aria-controls={TRANSACTION_STATUS.FINISH}
						aria-selected={selected_tab === TRANSACTION_STATUS.FINISH}
						className={setClassNameCondition(selected_tab === TRANSACTION_STATUS.FINISH, 'active show', '', 'nav-link')}>
						<span data-v-2bbc4f3d="" className="text-uppercase">{t("Close")}</span>
					</a>
				</li>
			</ul>}
			<section data-v-2bbc4f3d=""
				className="ps-container scroll-area ps ps--theme_default ps--active-y"
				data-ps-id="1db45f1e-7dce-eb5b-4e53-83ab996f130d">
				<div data-v-2bbc4f3d="" id="myTabContent" className="tab-content h-100">
					<div data-v-5c253b3b="" data-v-2bbc4f3d="" style={{ overflow: 'auto' }}
						className="d-flex no-scrollbar flex-column justify-content-between h-100 overflow-auto">
						<div data-v-5c253b3b="" style={{ maxHeight: '563px' }}>
							{Object.entries(groupedTransaction).map(([date, items]) => {
								return (
									<div data-v-5c253b3b="" key={date}>
										<h5 className="mt-3">{date}</h5>
										{items.map((item, index) => (
											<div data-v-5c253b3b=""
												key={`${date}-${index}`} 
												className="transactionBox font-14 mb-2">
												<div className="play-history">
													<div data-v-5c253b3b=""
														className="d-flex justify-content-between mb-2">
														<span
															data-v-5c253b3b=""
															className="font-14 font-weight-700">BTC/USDT
															{item['point_type'] === 'demo' && <span
																data-v-5c253b3b=""
																className="accType font-10">Demo
															</span>}
														</span>
													</div>
													<div data-v-5c253b3b=""
														className="d-flex justify-content-between mb-2"><span
															data-v-5c253b3b=""
															className="trendGroup d-flex align-items-center"><span
																data-v-5c253b3b=""
																className={setClassNameCondition(item['bet_condition'] === 'up', 'trendUp', 'trendDown', 'trendIcon mr-2')} /> <span
																	data-v-5c253b3b=""
																	className="text-uppercase">{betCondition(item)}</span></span>
														<span
															data-v-5c253b3b=""
															className="font-12m">${item.bet_value}</span>
													</div>
													<div data-v-5c253b3b=""
														className="d-flex justify-content-between">
														<div data-v-5c253b3b="" className="font-12 time">
															<span>{convertDate(item['created_at']).time}</span>
														</div>
														<span data-v-5c253b3b=""
															className={setClassNameCondition(item.value > 0, 'winUp', 'winDown', 'totalWin font-weight-700 font-12m')}>
															{item.value > 0 ? `+${(item.value + item.bet_value).toFixed(2)}$` : '0$'}
														</span>
													</div>
												</div>
											</div>
										))}
									</div>
								);
							})}
							{transactions.length >= 10 && isDesktop() && <div className="w-100 d-flex justify-content-center">
								<button onClick={this.goToDashBoard} href="dashboard" className="btn btn-primary" style={{ backgroundColor: 'transparent' }}>Xem thêm</button>
							</div>}
						</div>
					</div>
				</div>
			</section>
		</div>
	}
}


function mapStateToProps(state) {
	return {
		appReducer: state.appReducer,
		transactionReducer: state.transactionReducer
	};
}

// tạo funtion chuyển 2024-11-11 10:14:38 thành ngày tháng năm, giờ phút giây
function convertDate(date) {
	let date_time = new Date(date);
	let hours = String(date_time.getHours()).padStart(2, '0');
	let minutes = String(date_time.getMinutes()).padStart(2, '0');
	let seconds = String(date_time.getSeconds()).padStart(2, '0');
	return {
		date: `${date_time.getDate()}/${date_time.getMonth() + 1}/${date_time.getFullYear()}`,
		time: `${hours}:${minutes}:${seconds}`
	};
}

export default withRouter(connect(mapStateToProps, {
	fetchingTransactionAction,
	updateTransactionAction,
	updateAppConfigAction
})(withTranslation()(TransactionBox)));
